// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"c778cf47","90":"02da4309","427":"bec4484c","628":"89dd0136"}[chunkId] + ".chunk.js";
};